import { Injectable } from '@angular/core';

import { ConfigParserService } from './config-parser.service';

export interface EdgeworthConfig {
    calloutEnabled: boolean;
    deltaSyncApiPath: string;
    edgeworthApiRootPath: string;
    hideApiPath: string;
    substrateApiEndpoint: string;
    recentApiPath: string;
    reindexThresholdInDays: number;
    pinApiPath: string;
    periodicSyncIntervalInMin: number;
    recentItemsCount: number;
    unhideApiPath: string;
    unpinApiPath: string;
    userActionSortOrderEnabled: boolean;
    EdgeworthMSITFeatureEnabled: boolean;
    edgeworthS2SRecentEnabled: boolean;
    playListsEnabled: boolean;
    tabFocusSyncThrottleWindowInSeconds: number;
    tabFocusSyncThrottleWindowCount: number;
    meetingObjectsEnabled: boolean;
    edgeworthFloodgateEnabled: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class EdgeworthConfigService {
    public readonly config: EdgeworthConfig;

    constructor(configParserService: ConfigParserService) {
        this.config = configParserService.parse<EdgeworthConfig>('edgeworthConfig');
    }
}
